const StackTile = ({ label, icon: Icon }) =>
  Icon ? (
    <div className="w-16 h-16 shrink-0 flex flex-col items-center justify-center gap-1.5 rounded-lg border border-border bg-surface/40 hover:border-accent/60 transition-colors">
      <Icon className="w-5 h-5 text-white/80" />
      <span className="text-[10px] text-muted text-center leading-none px-1 truncate w-full">
        {label}
      </span>
    </div>
  ) : (
    <div className="w-16 h-16 shrink-0 flex items-center justify-center text-center px-1 rounded-lg border border-border bg-surface/40 hover:border-accent/60 transition-colors">
      <span className="text-[11px] font-mono text-white/80 leading-tight">
        {label}
      </span>
    </div>
  );

export default StackTile;
